<div
  class="popular-country-suggestions"
  *ngIf="this.nibtravelAutocomplete?.isShowDestinationSuggestion() | async"
  #root
>
  <h2>Popular destinations</h2>
  <div class="Qqc-row" style="width: 100%">
    <div
      class="Qqc-col-list"
      *ngFor="let region of popularDestinations$ | async; let first = first"
    >
      <p>
        <small class="fineprint">{{ region.name }}</small>
      </p>
      <div *ngFor="let country of region.countries" style="min-width: 100%">
        <button
          type="button"
          class="FilterInput-item"
          style="min-width: 100%"
          (click)="onClickHandler(country)"
        >
          {{ country.option.text }}
        </button>
      </div>
    </div>
  </div>
</div>
